import React, { FunctionComponent } from "react";
import { styled } from "@mui/material/styles";
import { observer } from "mobx-react-lite";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useStore } from "csi/state/hooks";

const PREFIX = "HashIcon";

const classes = {
	root: `${PREFIX}root`,
};

const StyledSvgIcon = styled(SvgIcon)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		"& > *": {
			fill: "currentColor",
		},
	},
}));

export const HashIcon: FunctionComponent<SvgIconProps> = observer((props) => {
	const { routerStore } = useStore();
	const { locationNode } = routerStore;


	return (
		<StyledSvgIcon
			className={locationNode.SlackChannels.length ? null : classes.root}
			viewBox="-2 -4 16 16"
			{...props}
		>
			<path d="M2.4426 9.44455L2.82587 7.46924H0.666626L0.85556 6.48159H3.0148L3.587 3.51863H1.42776L1.61669 2.53097H3.77594L4.1592 0.555664H5.23883L4.85556 2.53097H8.09443L8.47769 0.555664H9.55732L9.17405 2.53097H11.3333L11.1444 3.51863H8.98512L8.41292 6.48159H10.5722L10.3832 7.46924H8.22398L7.84072 9.44455H6.76109L7.14436 7.46924H3.90549L3.52223 9.44455H2.4426ZM4.66663 3.51863L4.09443 6.48159H7.33329L7.90549 3.51863H4.66663Z" fill="#1D2129" />
		</StyledSvgIcon>
	);
});

export default HashIcon;
